__turbopack_context__.v({
  "material-icon": "MaterialIcon-module-scss-module__bxzTvW__material-icon",
});
